<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </template>
      <template #extra>
        <vxe-button :disabled="!order.isNew()" content="button.reset" icon="vxe-icon-undo" mode="text" status="danger" @click="clear"/>
        <vxe-button :disabled="order.orderStatus>0" content="button.addDetail" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
        <vxe-button :disabled="order.orderStatus>0" content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
        <vxe-button :disabled="order.orderStatus>0" content="button.submit" icon="vxe-icon-signature" mode="text" status="primary" @click="submit"/>
        <!--          <a-upload :multiple="true" name="file">-->
        <!--            <a-button type="primary" @click="importExcel">-->
        <!--              <a-icon type="upload" />-->
        <!--              {{ $t('button.impConfirm') }}-->
        <!--            </a-button>-->
        <!--          </a-upload>-->
      </template>
      <a-form-model :colon="false" :label-col="{span:8}" :model="order" :rules="rules" :wrapper-col="{span:16}">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.orderNo')" prop="no">
              <vxe-input v-model="order.no" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.orderType')" prop="orderType">
              <vxe-input v-model="order.orderType.name" :disabled="order.orderStatus>0" :editable="false" style="width: 100%" @click="onOrderTypeSelect"/>
              <order-type-modal ref="orderTypeModal" @change="onOrderTypeChange"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.owner')" prop="owner">
              <vxe-select v-model="order.owner.id" :disabled="order.orderStatus>0" :options="owners" style="width: 100%" @change="onOwnerChange"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.supplier')" prop="supplier">
              <vxe-input v-model="order.supplier.name" :disabled="order.orderStatus>0" :editable="false" style="width: 100%" @click="onSupplierSelect"/>
              <customer-modal ref="customerModal" title="business.label.supplier" @change="onSupplierChange"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.maker')" prop="operator">
              <vxe-input v-model="order.operator" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.buyer')" prop="buyer">
              <vxe-input v-model="order.buyer" :disabled="order.orderStatus>0" :editable="false" style="width: 100%" @click="onBuyerSelect"/>
              <user-modal ref="userModal" @change="onBuyerChange"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-card>
    <vxe-table ref="table" :data="order.details" :edit-config="{trigger:this.order.orderStatus>0?'manual':'click'}" :edit-rules="editRules" :loading="loading" :min-height="720" keep-source>
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column :edit-render="itemRender" field="item.no" title="business.label.itemNo" width="100"/>
      <vxe-column field="item.name" title="business.label.itemName" width="200"/>
      <vxe-column :edit-render="packRender" field="pack.specification" title="business.label.specification" width="200"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column :edit-render="lotRender" field="lotNo" title="business.label.lot" width="120"/>
      <vxe-column :edit-render="dateRender" field="productionDate" title="business.label.productionDate" width="120"/>
      <vxe-column :edit-render="dateRender" field="validUntil" title="business.label.validUntil" width="120"/>
      <vxe-column :edit-render="textRender" field="manufacturer" title="business.label.manufacturer" width="200"/>
      <vxe-column :edit-render="textRender" field="producingArea" title="business.label.producingArea" width="120"/>
      <vxe-column :edit-render="textRender" field="approvalNo" title="business.label.approvalNo" width="150"/>
      <vxe-column :edit-render="numberRender" field="plannedQuantity" title="business.label.plannedQuantity" width="150"/>
      <vxe-column :edit-render="numberRender" field="price" title="business.label.price" width="120"/>
      <vxe-column fixed="right" title="business.label.operate" width="auto">
        <vxe-button-group slot-scope="{row}" mode="text">
          <vxe-button :disabled="order.orderStatus>0" content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
        </vxe-button-group>
      </vxe-column>
    </vxe-table>
    <item-modal ref="itemModal" @change="onItemChange"/>
    <pack-modal ref="packModal" @change="onPackChange"/>
    <lot-modal ref="lotModal" @change="onLotChange"/>
  </div>
</template>

<script>
import Vue from 'vue'
import Api from '@/api'
import { deleteOne, findAll, post } from '@/api/Api'
import moment from 'moment'
import { OPERATOR, WAREHOUSE } from '@/store/mutation-types'
import UserModal from '@/views/modal/UserModal.vue'
import OrderTypeModal from '@/views/modal/OrderTypeModal.vue'
import CustomerModal from '@/views/modal/CustomerModal.vue'
import ItemModal from '@/views/modal/ItemModal.vue'
import PackModal from '@/views/modal/PackModal.vue'
import LotModal from '@/views/modal/LotModal.vue'
import { BaseObject } from '@/api/dto/BaseObject'
import { PurchaseDetail, PurchaseOrder } from '@/api/dto/order/PurchaseOrder'
import { OrderType } from '@/api/dto/common/OrderType'
import { Party } from '@/api/dto/common/Party'
import { Item } from '@/api/dto/common/Item'
import { Pack } from '@/api/dto/common/Pack'

export default {
  name: 'PurchaseOrderDetail',
  components: { CustomerModal, ItemModal, LotModal, OrderTypeModal, PackModal, UserModal },
  props: {
    owners: { type: Array, default: [] }
  },
  data() {
    return {
      loading: false,
      operator: Vue.ls.get(OPERATOR),
      warehouse: Vue.ls.get(WAREHOUSE),
      order: new PurchaseOrder(),
      rules: {
        orderType: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        owner: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        supplier: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      },
      editRules: {
        'item.no': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        'item.name': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        'pack.specification': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        'plannedQuantity': [{ required: true, min: 1, type: 'number', message: '计划数量需大于0' }]
      },
      textRender: {
        name: 'VxeInput',
        autoFocus: true,
        autoSelect: true
      },
      numberRender: {
        name: 'VxeNumberInput',
        autoFocus: true,
        autoSelect: true,
        props: {
          min: 0
        }
      },
      dateRender: {
        name: 'VxeDatePicker',
        autoFocus: true,
        autoSelect: true
      },
      itemRender: {
        name: 'VxeInput',
        placeholder: '点击选择',
        events: {
          click: ({ row }) => this.onItemSelect(row),
          clear: ({ row }) => {
            row.item = new Item()
            row.pack = new Pack()
            row.lotNo = ''
            row.productionDate = ''
            row.validUntil = ''
            row.manufacturer = ''
            row.producingArea = ''
            row.approvalNo = ''
          }
        }
      },
      packRender: {
        name: 'VxeInput',
        placeholder: '点击选择',
        events: {
          click: ({ row }) => this.onPackSelect(row),
          clear: ({ row }) => row.pack = new Pack()
        }
      },
      lotRender: {
        name: 'VxeInput',
        placeholder: '点击选择',
        events: {
          click: ({ row }) => this.onLotSelect(row),
          clear: ({ row }) => {
            row.lotNo = ''
            row.productionDate = ''
            row.validUntil = ''
            row.manufacturer = ''
            row.producingArea = ''
            row.approvalNo = ''
          }
        }
      }
    }
  },
  created() {
    this.order.operator = this.operator.name
    this.order.buyer = this.operator.name
  },
  methods: {
    moment,
    back() {
      this.$emit('back')
    },
    fetch(row) {
      this.order = new PurchaseOrder(BaseObject.merge(row, 'order'))
      this.getDetails()
    },
    getDetails() {
      if (this.order.isNew()) return
      this.loading = true
      findAll('purchaseDetailFactory', { 'order.id': this.order.id }).then(res => {
        if (res.success) {
          this.order.details = res.result.map(item => {
            return new PurchaseDetail(BaseObject.merge(item, 'purchaseDetail'))
          })
        }
      }).finally(() => this.loading = false)
    },
    onOrderTypeSelect() {
      this.$refs.orderTypeModal.open({ available: true, operationType: 1, refundable: false })
    },
    onOrderTypeChange(data) {
      this.order.orderType = new OrderType(data[0])
    },
    onOwnerChange() {
      this.order.supplier = new Party()
      this.order.details = []
    },
    onSupplierSelect() {
      if (this.checkOwner()) {
        this.$refs.customerModal.open({ available: true, 'type.ordinal': 2, 'owner.id': this.order.owner.id })
      }
    },
    onSupplierChange(data) {
      this.order.supplier = new Party(data[0])
    },
    onBuyerSelect() {
      this.$refs.userModal.open({ available: true })
    },
    onBuyerChange(data) {
      this.order.buyer = data.length > 0 ? data[0].name : ''
    },
    onItemSelect(row) {
      if (this.checkOwner()) {
        this.$refs.itemModal.open({ 'owner.id': this.order.owner.id }, row)
      }
    },
    onItemChange(data, row) {
      row.item = new Item(data[0])
      row.pack = new Pack()
      this.onLotChange([], row)
    },
    onPackSelect(row) {
      if (this.checkItem(row)) {
        this.$refs.packModal.open({ 'item.id': row.item.id }, row)
      }
    },
    onPackChange(data, row) {
      row.pack = new Pack(data[0])
    },
    onLotSelect(row) {
      if (this.checkItem(row)) {
        this.$refs.lotModal.open({ 'item.id': row.item.id }, row)
      }
    },
    onLotChange(data, row) {
      if (data.length > 0) {
        const lot = data[0]
        row.lotNo = lot.no
        row.productionDate = lot.productionDate
        row.validUntil = lot.validUntil
        row.manufacturer = lot.manufacturer
        row.producingArea = lot.producingArea
        row.approvalNo = lot.approvalNo
      } else {
        row.lotNo = ''
        row.productionDate = ''
        row.validUntil = ''
        row.manufacturer = ''
        row.producingArea = ''
        row.approvalNo = ''
      }
    },
    checkOwner() {
      if (this.order.owner.isNew()) {
        this.$message.warning(this.$t('business.label.owner') + this.$t('message.canNotBeEmpty'))
        return false
      }
      return true
    },
    checkItem(row) {
      if (row.item.isNew()) {
        this.$message.warning(this.$t('business.label.item') + this.$t('message.canNotBeEmpty'))
        return false
      }
      return true
    },
    verify() {
      if (this.order.orderType.isNew()) {
        this.$message.warning(this.$t('business.label.orderType') + this.$t('message.canNotBeEmpty'))
        return false
      }
      if (this.order.owner.isNew()) {
        this.$message.warning(this.$t('business.label.owner') + this.$t('message.canNotBeEmpty'))
        return false
      }
      if (this.order.supplier.isNew()) {
        this.$message.warning(this.$t('business.label.supplier') + this.$t('message.canNotBeEmpty'))
        return false
      }
      if (this.order.details.length === 0) {
        this.$message.warning(this.$t('tab.orderDetail') + this.$t('message.canNotBeEmpty'))
        return false
      }
      return true
    },
    reset() {
      this.order = new PurchaseOrder()
      this.order.orderStatus = 0
      this.order.operator = this.operator.name
      this.order.buyer = this.operator.name
    },
    clear() {
      const that = this
      that.$confirm({
        title: '将清空界面数据',
        content: '是否确定',
        onOk() {
          that.reset()
        },
        onCancel() {
        },
        centered: true
      })
    },
    add() {
      this.order.details.push(new PurchaseDetail())
    },
    async save() {
      const pass = this.verify()
      if (!pass) {
        return
      }
      const table = this.$refs.table
      const errMap = await table.validate(true)
      if (!errMap) {
        this.loading = true
        const order = this.order.toJSONObject()
        order.warehouse = this.warehouse
        order.details = this.order.details.map(dtl => dtl.toJSONObject())
        post(Api.buyingSave, { type: 'omsPlan' }, order).then(res => {
          if (res.success) {
            this.order = new PurchaseOrder(res.result)
            this.getDetails()
            this.$message.success(this.$t('message.saveSuccess'))
          }
        }).finally(() => this.loading = false)
      }
    },
    async submit() {
      await this.save()
      this.loading = true
      post(Api.buyingSubmit, { type: 'omsPlan' }, { id: this.order.id }).then(res => {
        if (res.success) {
          this.$success({ title: '提交成功', centered: true })
          this.order = new PurchaseOrder(res.result)
          this.getDetails()
        }
      }).finally(() => this.loading = false)
    },
    remove(row) {
      if (row.id) {
        this.loading = true
        deleteOne('purchaseDetailDeleter', { id: row.id }).then(res => {
          if (res.success) {
            this.$message.success(this.$t('message.deleteSuccess'))
            this.fetch()
          }
        }).finally(() => this.loading = false)
      } else {
        this.order.details.splice(this.order.details.indexOf(row), 1)
      }
    }
  }
}
</script>